import { FC, useEffect } from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { hotjar } from "react-hotjar";
import SvgGradients from "./SvgGradients";

interface Props {
    children: React.ReactNode;
}

const AppPage: FC<Props> = ({ children }) => {
    useEffect(() => {
        // Initialize hotjar only on staging
        if (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "staging") {
            hotjar.initialize(3230069, 6);
        } else if (
            process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "production"
        ) {
            hotjar.initialize(3315186, 6);
        }
    }, []);

    return (
        <>
            <div>
                <SvgGradients />
                <SkeletonTheme borderRadius={100}>{children}</SkeletonTheme>
            </div>
            <ReactQueryDevtools initialIsOpen={false} />
        </>
    );
};

export default AppPage;
